<template>
  <div class="upload-box">
    <div class="avatar-uploader-box">
      <!-- 图片预览 -->
      <div
        :key="index"
        class="video-preview"
        v-for="(item, index) in videoList"
      >
        <video
          v-if="item.video_url_str"
          :src="item.video_url_str"
          @mouseover.stop="item.isShowPopup = true"
          class="avatar"
        >
          您的浏览器不支持视频播放
        </video>
        <!-- 显示查看和删除的按钮弹窗 -->
        <div
          @mouseleave="item.isShowPopup = false"
          class="avatar-uploader-popup"
          v-show="item.video_url_str && item.isShowPopup"
        >
          <i @click="previewVideo(item)" class="el-icon-zoom-in"></i>
          <i
            v-if="isDel"
            @click="deleteVideo(index)"
            class="el-icon-delete"
          ></i>
        </div>
      </div>

      <!-- 方框样式 -->
      <el-upload
        v-show="uploadShow"
        :action="actionUrl"
        :auto-upload="false"
        :on-change="handleAvatarChange"
        :show-file-list="false"
        class="avatar-uploader"
        ref="avatarUploader"
      >
        <span
          element-loading-background="rgba(0, 0, 0, 0.8)"
          element-loading-spinner="el-icon-loading"
          element-loading-text="上传中"
          style="display: block"
          v-loading="loading"
        >
          <i class="el-icon-plus avatar-uploader-icon"></i>
        </span>
      </el-upload>

      <!-- 上传提示文字样式 -->
      <div class="upload-tip">
        <slot></slot>
      </div>
    </div>

    <!-- 查看大图 -->
    <el-dialog
      :visible.sync="dialogVisible"
      append-to-body
      center
      title="视频查看"
      :before-close="handleClose"
    >
      <video :src="videoSrc" ref="video" controls alt width="100%">
        您的浏览器不支持视频播放
      </video>
    </el-dialog>
  </div>
</template>

<script>
import common from "@/api/common";
export default {
  name: "UploadVideo",
  components: {},
  props: {
    videos: {
      type: Array,
      default: function () {
        return [];
      },
    },
    numLimit: {
      // 最大允许上传个数
      type: Number,
      default: 1,
    },
    sizeLimit: {
      // 最大单文件大小
      type: Number,
      default: 200,
    },
    isDel: {
      // 是否删除
      type: Boolean,
      default: true,
    },
    isUploadCover: {
      // 是否上传封面
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      videoList: [],
      videoSrc: "",
      actionUrl: "",
      coverImg: {},
      filename: "",
    };
  },
  computed: {
    uploadShow() {
      return this.videoList.length < this.numLimit;
    },
  },
  watch: {
    videos: {
      handler() {
        const isArray = Array.isArray(this.videos);
        if (isArray && this.videos.length > 0) {
          this.videos.map((item) => {
            item.isShowPopup = false;
          });
          this.videoList = JSON.parse(JSON.stringify(this.videos));
        } else {
          this.videoList = [];
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {},
  methods: {
    // 上传之前
    beforeAvatarUpload(file) {
      return new Promise((resolve, reject) => {
        if (
          [
            "video/mp4",
            "video/ogg",
            "video/flv",
            "video/avi",
            "video/wmv",
            "video/rmvb",
            "video/mov",
          ].indexOf(file.raw.type) == -1
        ) {
          // eslint-disable-next-line prefer-promise-reject-errors
          return reject("请上传正确的视频格式!");
        }

        if (file.size / 1024 / 1024 > this.sizeLimit) {
          // eslint-disable-next-line prefer-promise-reject-errors
          return reject(`视频大小不能超过${this.sizeLimit}M!`);
        }

        if (this.videoList.length === this.numLimit) {
          // eslint-disable-next-line prefer-promise-reject-errors
          return reject(`最多上传${this.numLimit}个视频`);
        }

        resolve("符合表單規則");
      });
    },
    // 上传改变
    async handleAvatarChange(file, fileList) {
      try {
        await this.beforeAvatarUpload(file);
        this.uploadImgApi(file);
      } catch (e) {
        this.$message.warning(JSON.stringify(e));
      }
    },

    // 上传视频准备
    uploadImgApi(data) {
      this.loading = true;
      this.filename = data.name;
      const suffix = this.filename.substring(this.filename.lastIndexOf("."));
      const formData = new FormData();
      formData.append("image", data.raw);
      formData.append("img_type", 3);
      formData.append("suffix", suffix);
      if (this.isUploadCover) {
        let name = this.filename.substring(0, this.filename.lastIndexOf("."));
        this.getblob(data.raw, name + ".png");
      }
      common
        .uploadFile(formData)
        .then((res) => {
          let { code, data } = res;
          if (code === 0) {
            this.videoList.push({
              video_url_str: data.path,
              video_url: data.pic,
              isShowPopup: false,
              filename: this.filename,
            });
            this.$nextTick(() => {
              this.$emit("change", this.videoList);
            });
          }
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    // 预览视频
    previewVideo(data) {
      this.videoSrc = data.video_url_str;
      this.dialogVisible = true;
    },
    // 删除视频
    deleteVideo(index) {
      this.videoList.splice(index, 1);
      console.log(this.videoList);
    },
    handleClose() {
      const video = document.getElementsByTagName("video")[1];
      if (!video.paused) {
        video.currentTime = 0;
        video.pause();
      }
      this.dialogVisible = false;
    },
    /**
     * 获取视频第一帧作为回显封面
     *
     */
    getVideoCover(fileUrl, filename) {
      const video = document.createElement("video"); // 也可以自己创建video
      video.src = fileUrl; // url地址 url跟 视频流是一样的
      let canvas = document.createElement("canvas"); // 获取 canvas 对象
      const ctx = canvas.getContext("2d"); // 绘制2d
      video.crossOrigin = "anonymous"; // 解决跨域问题，也就是提示污染资源无法转换视频
      video.currentTime = 1; // 第一帧
      video.oncanplay = () => {
        canvas.width = video.clientWidth ? video.clientWidth : 320; // 获取视频宽度
        canvas.height = video.clientHeight ? video.clientHeight : 320; //获取视频高度
        // 利用canvas对象方法绘图
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        // 转换成base64形式
        let _videoFirstimgsrc = canvas.toDataURL("image/png"); // 截取后的视频封面
        this.uploadImg(_videoFirstimgsrc, ".png");
        video.remove();
        canvas.remove();
      };
    },
    // 上传封面
    uploadImg(base64, filename) {
      const file = this.dataURLtoFile(base64, filename);
      const formData = new FormData();
      formData.append("image", file);
      formData.append("img_type", 4);
      formData.append("suffix", ".png");
      common.uploadFile(formData).then((res) => {
        let { code, data } = res;
        if (code === 0) {
          this.coverImg = data;
          this.$emit("uploadCover", data);
        }
      });
    },
    getblob(file, filename) {
      let reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onload = (e) => {
        let data;
        if (typeof e.target.result === "object") {
          data = window.URL.createObjectURL(new Blob([e.target.result]));
        } else {
          data = e.target.result;
        }
        this.getVideoCover(data, filename);
      };
    },
    dataURLtoFile(base64, filename) {
      const arr = base64.split(",");
      const typeMatch = arr[0].match(/:(.*?);/);
      const mime = typeMatch[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
  },
};
</script>

<style lang="scss">
$width: 100px;
$height: 100px;

.upload-box {
  position: relative;
  width: 100px;
  .avatar-uploader-box {
    position: relative;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding-bottom: 20px;
    min-width: 350px;
    box-sizing: border-box;
    .avatar-uploader {
      .el-upload {
        width: $width;
        height: $height;
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        &:hover {
          border-color: #409eff;
        }
        .el-loading-spinner {
          width: $width;
          height: $height;
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          margin-top: 0;
          top: 0;
          .el-loading-text {
            margin: 0;
          }
        }
      }
      .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: $width;
        height: $height;
        line-height: $height;
        text-align: center;
      }
    }
    .video-preview {
      position: relative;
      padding-right: 20px;
      .avatar {
        width: $width;
        height: $height;
        display: block;
        border-radius: 6px;
      }
      .avatar-uploader-popup {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
        width: $width;
        height: $height;
        background: rgba($color: #000000, $alpha: 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        font-size: 20px;
        border-radius: 6px;
        i {
          width: 30%;
          text-align: center;
          padding: 0 5%;
          font-size: 24px;
        }
      }
    }
    .upload-tip {
      position: absolute;
      bottom: 0;
      left: 0;
      font-size: 12px;
      color: #606266;
      max-width: 350px;
      line-height: 20px;
    }
  }
}
</style>
